import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Body from "./components/Body";
import Advert from "./components/Advert";
import Footer from "./components/Footer"

function App() {
  return (
    <div className="App">
       <Navbar/>
       <Header/>
       <Body/>
       <Advert/>
       <Footer/>

    </div>
  );
}

export default App;
